<template>
  <div class="header">
    <van-nav-bar
      v-if="showNavBar"
      :title="title"
    />
  </div>
</template>
<script>
export default {
  name: 'NavigationBar',
  props: {
    title: {
      type: String,
      default: () => ''
    },
    leftIcon: {
      type: String,
      default: () => 'left'
    },
    backgroundType: {
      type: String,
      default: () => 'light'
    }
  },
  data() {
    return {
      backgroundColor: {
        write: '#ffffff',
        light: '#0E5EA4'
      }
    }
  }
}
</script>
